module.exports = __webpack_public_path__ + "officialStatic/img/olt-detailList14.1c76867.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/olt-detailList14.png
// module id = 48re
// module chunks = 0